'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleAuthRedirect;

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNAUTHENTICATED_MESSAGE = 'Authentication required to access this page.';
var UNAUTHORIZED_MESSAGE = 'Not authorized to access this page.';

function throwApiError(response, message) {
  var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : response.status;

  var error = new Error(message);
  if (response.status !== status) {
    /* eslint-disable no-param-reassign */
    response.originalStatus = response.status;
    response.status = status;
    /* eslint-enable no-param-reassign */
  }
  error.response = response;
  throw error;
}

/**
 * This transforms a 302 redirect to the login page to either a 401 or 403 depending
 * on the `reason` query param.
 */
function handleAuthRedirect(response) {
  if (response.status !== 302) {
    return response;
  }
  var location = response.headers.location;

  var url = (0, _urlParse2.default)(location, true);
  if (/^\/auth\/login\//.test(url.pathname)) {
    if (url.query.reason === 'unauthenticated') {
      throwApiError(response, UNAUTHENTICATED_MESSAGE, 401);
    } else if (url.query.reason === 'unauthorized') {
      throwApiError(response, UNAUTHORIZED_MESSAGE, 403);
    }
  }
  return response;
}